/** Parsen en matchen van geplakte bestellijsten (artikelnummer + aantal per regel). */

const norm = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
const woorden = (value) =>
  String(value || "")
    .toLowerCase()
    .split(/[^a-z0-9äöüéèçß]+/i)
    .filter((w) => w.length > 2);

/** "NB1064;12", "FR1005 6", "FR1001, 24", "NB1064 x 6" -> {code, aantal} */
export function parseQuickOrder(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((raw) => raw.trim())
    .filter(Boolean)
    .map((line) => {
      const match = line.match(/^(.*?)[\s;,]*(?:x|X|\*)?[\s;,]+(\d+(?:[.,]\d+)?)\s*$/);
      if (match && match[1].trim()) {
        return { invoer: line, code: match[1].trim(), aantal: Number(match[2].replace(",", ".")) };
      }
      return { invoer: line, code: line, aantal: 1 };
    });
}

/** Artikelnummer eerst; anders de beste treffer op naam als voorstel. */
export function matchQuickOrder(code, producten) {
  const key = norm(code);
  if (!key) return null;

  const exact = producten.find((p) => norm(p.sku) === key || norm(p.id) === key);
  if (exact) return { product: exact, zeker: true, reden: "sku" };

  const deel = producten.find((p) => norm(p.sku) && (norm(p.sku).startsWith(key) || key.startsWith(norm(p.sku))));
  if (deel && key.length >= 4) return { product: deel, zeker: true, reden: "sku" };

  const termen = woorden(code);
  if (termen.length === 0) return null;
  let beste = null;
  producten.forEach((p) => {
    const naam = woorden(p.naam).join(" ");
    const score = termen.filter((term) => naam.includes(term)).length;
    if (score > 0 && (!beste || score > beste.score)) beste = { product: p, score };
  });
  if (beste && beste.score >= Math.max(1, Math.ceil(termen.length / 2))) {
    return { product: beste.product, zeker: false, reden: "naam" };
  }
  return null;
}

/** Volledige lijst omzetten naar regels met status. */
export function buildQuickOrder(text, producten) {
  return parseQuickOrder(text).map((regel, index) => {
    const treffer = matchQuickOrder(regel.code, producten || []);
    return {
      key: `${index}-${regel.code}`,
      ...regel,
      product: treffer?.product || null,
      zeker: Boolean(treffer?.zeker),
      reden: treffer?.reden || null,
    };
  });
}
